export default "/images/f32b584319a324e35c9302077e7fd653.avif";